import classnames from 'classnames';
import { ReactComponentLike } from 'prop-types';
import React from 'react';
import Typography from '~components/typography/typography';
import { useTranslation } from '~i18n';
import styles from './list-group.module.scss';

interface ListGroupProps extends React.HTMLProps<HTMLElement> {
  className?: string;
  tag?: ReactComponentLike;
  onSelectAll?: (e: React.MouseEvent<any>) => void;
}

const ListGroup = React.forwardRef<any, ListGroupProps & React.HTMLAttributes<any>>(
  ({ tag: Tag = 'ul', className = '', onSelectAll, children, ...otherProps }, ref) => {
    const { t } = useTranslation();

    return (
      <Tag ref={ref} className={classnames(styles.root, className)} {...otherProps}>
        {children}
        {onSelectAll && (
          <Typography
            component="div"
            className={styles.selectAll}
            onClick={onSelectAll}
            variant="body2"
          >
            {t('select_all')}
          </Typography>
        )}
      </Tag>
    );
  }
);

export default ListGroup;
